/* Thryve theme v2.2.0: menu, reveals, variants, AJAX cart + drawer, collection toolbar, landing clock, galleries */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- Collection toolbar (sort + filters auto-submit) ---------- */
    document.querySelectorAll('[data-collection-toolbar]').forEach(function (form) {
      var submit = function () {
        var params = new URLSearchParams(new FormData(form));
        var url = form.getAttribute('action') || window.location.pathname;
        window.location.href = url + (params.toString() ? '?' + params.toString() : '');
      };
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-sort-select], input[type="checkbox"]')) submit();
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      // Close open filter dropdowns when clicking outside
      document.addEventListener('click', function (e) {
        form.querySelectorAll('details[open]').forEach(function (d) {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      });
    });


    /* ---------- Countdown bar ---------- */
    document.querySelectorAll('[data-countdown]').forEach(function (bar) {
      var raw = (bar.getAttribute('data-countdown-end') || '').trim();
      if (!raw) return;
      // Parse "YYYY-MM-DD HH:MM" as local time
      var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
      var end = m
        ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 0)
        : new Date(raw);
      if (isNaN(end.getTime())) return;

      var els = {
        days: bar.querySelector('[data-cd-days]'),
        hours: bar.querySelector('[data-cd-hours]'),
        mins: bar.querySelector('[data-cd-mins]'),
        secs: bar.querySelector('[data-cd-secs]')
      };
      var display = bar.querySelector('[data-countdown-display]');
      var done = bar.querySelector('[data-countdown-done]');
      var hideWhenDone = bar.getAttribute('data-countdown-hide') === 'true';
      var reducedCd = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function setVal(el, v) {
        if (!el) return;
        if (el.textContent !== v) {
          el.textContent = v;
          if (!reducedCd) {
            el.classList.remove('tick');
            void el.offsetWidth;
            el.classList.add('tick');
          }
        }
      }

      function finish() {
        clearInterval(timer);
        if (hideWhenDone) { bar.hidden = true; return; }
        if (display) display.hidden = true;
        if (done) done.hidden = false;
      }

      function render() {
        var diff = end.getTime() - Date.now();
        if (diff <= 0) { finish(); return; }
        var s = Math.floor(diff / 1000);
        setVal(els.days, pad(Math.floor(s / 86400)));
        setVal(els.hours, pad(Math.floor(s % 86400 / 3600)));
        setVal(els.mins, pad(Math.floor(s % 3600 / 60)));
        setVal(els.secs, pad(s % 60));
      }

      render();
      var timer = setInterval(render, 1000);
    });

    /* ---------- Landing clock (homepage only) ---------- */
    var clockEl = document.querySelector('[data-landing-clock]');
    if (clockEl) {
      var clockFmt = new Intl.DateTimeFormat('en-US', {
        month: '2-digit', day: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: true
      });
      var renderClock = function () {
        var parts = {};
        clockFmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
        clockEl.textContent = parts.month + '/' + parts.day + '/' + parts.year + ' ' +
          parts.hour + ':' + parts.minute + parts.dayPeriod.toLowerCase();
      };
      renderClock();
      setInterval(renderClock, 15000);
    }

    /* ---------- Product gallery thumbnail swap ---------- */
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-full-src');
          main.alt = thumb.getAttribute('data-full-alt') || '';
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });

      /* Click-to-zoom lightbox: native <dialog>, no library. */
      var zoomTrigger = gallery.querySelector('[data-gallery-zoom]');
      var lightbox = gallery.querySelector('[data-gallery-lightbox]');
      var lightboxImg = lightbox && lightbox.querySelector('[data-gallery-lightbox-img]');
      if (zoomTrigger && lightbox && lightboxImg && typeof lightbox.showModal === 'function') {
        zoomTrigger.addEventListener('click', function () {
          lightboxImg.src = main.src;
          lightboxImg.alt = main.alt;
          lightbox.showModal();
        });
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox) lightbox.close();
        });
        var lightboxClose = lightbox.querySelector('[data-gallery-lightbox-close]');
        if (lightboxClose) lightboxClose.addEventListener('click', function () { lightbox.close(); });
      } else if (zoomTrigger) {
        zoomTrigger.setAttribute('tabindex', '-1');
      }
    });

    /* ---------- Look viewer (lookbook detail) ---------- */
    document.querySelectorAll('[data-look-viewer]').forEach(function (viewer) {
      var main = viewer.querySelector('[data-look-main]');
      var title = viewer.querySelector('[data-look-title]');
      var current = viewer.querySelector('[data-look-current]');
      var thumbs = Array.prototype.slice.call(viewer.querySelectorAll('[data-look-thumb]'));
      if (!main || !thumbs.length) return;
      var index = 0;

      function show(i) {
        index = (i + thumbs.length) % thumbs.length;
        var thumb = thumbs[index];
        var src = thumb.getAttribute('data-full-src');
        if (src) {
          main.src = src;
          main.alt = thumb.getAttribute('data-look-name') || '';
        }
        if (title) title.textContent = thumb.getAttribute('data-look-name') || '';
        if (current) current.textContent = index + 1;
        thumbs.forEach(function (t, n) {
          t.classList.toggle('is-active', n === index);
          t.setAttribute('aria-current', n === index ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb, n) {
        thumb.addEventListener('click', function () { show(n); });
      });
      var prev = viewer.querySelector('[data-look-prev]');
      var next = viewer.querySelector('[data-look-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });
      show(0);
    });

    /* ---------- Scroll reveal ---------- */
    var reveals = document.querySelectorAll('.reveal');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window && reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
    }

    /* ---------- Cart drawer ---------- */
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    var openBtns = document.querySelectorAll('[data-cart-open]');
    var lastFocus = null;

    function openDrawer() {
      if (!drawer || !overlay) return;
      lastFocus = document.activeElement;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        drawer.classList.add('is-open');
      });
      drawer.setAttribute('aria-hidden', 'false');
      drawer.focus();
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      if (!drawer || !overlay) return;
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { overlay.hidden = true; }, 320);
      if (lastFocus) lastFocus.focus();
    }

    openBtns.forEach(function (b) { b.addEventListener('click', openDrawer); });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    var closeBtn = document.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* ---------- Cart state sync ---------- */
    function refreshCart() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Count with roll animation
          var count = document.querySelector('[data-cart-count]');
          if (count) {
            count.textContent = cart.item_count;
            count.classList.toggle('is-empty', cart.item_count === 0);
            count.classList.remove('roll');
            void count.offsetWidth;
            count.classList.add('roll');
          }
          // Icon bump
          var cartIcon = document.querySelector('[data-cart-open]');
          if (cartIcon) {
            cartIcon.classList.remove('bump');
            void cartIcon.offsetWidth;
            cartIcon.classList.add('bump');
          }
          // Drawer lines
          var lines = document.querySelector('[data-cart-lines]');
          if (lines) {
            if (cart.items.length === 0) {
              lines.innerHTML = '<p class="cart-drawer__empty">Your cart is empty. That\'s fixable.</p>';
            } else {
              lines.innerHTML = cart.items.map(function (item) {
                var img = item.image
                  ? '<img class="cart-drawer__img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') + '" alt="" loading="lazy">'
                  : '';
                var variant = (item.variant_title && item.variant_title !== 'Default Title')
                  ? '<p class="cart-drawer__line-variant">' + item.variant_title + '</p>' : '';
                return '<div class="cart-drawer__line">' + img +
                  '<div class="cart-drawer__line-info">' +
                  '<p class="cart-drawer__line-title">' + item.product_title + '</p>' + variant +
                  '<p class="cart-drawer__line-qty">Qty ' + item.quantity + '</p></div>' +
                  '<p class="cart-drawer__line-price">' + money(item.final_line_price) + '</p></div>';
              }).join('');
            }
          }
          var subtotal = document.querySelector('[data-cart-subtotal]');
          if (subtotal) subtotal.textContent = money(cart.total_price);
          return cart;
        });
    }

    /* ---------- AJAX add to cart ---------- */
    var form = document.querySelector('.product-form[data-ajax-cart]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-button]');
        if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

        btn.classList.add('is-loading');

        var idInput = form.querySelector('[data-variant-id]');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(idInput.value, 10), quantity: 1 })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            return refreshCart();
          })
          .then(function () {
            setTimeout(function () {
              btn.classList.remove('is-added');
              openDrawer();
            }, 800);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            // Fall back to a normal form submit so the customer is never blocked
            form.submit();
          });
      });
    }

    /* ---------- Variant selection ---------- */
    if (form || document.querySelector('.product-form')) {
      var pform = form || document.querySelector('.product-form');
      var selects = pform.querySelectorAll('[data-option-select]');
      if (selects.length && window.location.pathname.indexOf('/products/') !== -1) {
        fetch(window.location.pathname + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            function updateVariant() {
              var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
              var match = product.variants.find(function (v) {
                return v.options.every(function (opt, i) { return opt === chosen[i]; });
              });
              var idInput = pform.querySelector('[data-variant-id]');
              var btn = pform.querySelector('[data-add-button]');
              var label = pform.querySelector('[data-add-label]');
              if (match) {
                idInput.value = match.id;
                if (btn) {
                  btn.disabled = !match.available;
                  if (label && !match.available) label.textContent = 'SOLD OUT';
                }
              }
            }
            selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
          })
          .catch(function () { /* server-rendered fallback */ });
      }
    }
  });
})();
